import { AdvertiserColumn } from "./entity/AdvertiserColumn.tsx";
import { AdvertisersColumn } from "./entity/AdvertisersColumn.tsx";
import { AffiliatesColumn } from "./entity/AffiliatesColumn.tsx";
import { OfferColumn } from "./entity/OfferColumn.tsx";
import { OwnerColumn } from "./entity/OwnerColumn.tsx";

export const TableColumn = {
    Entity: {
        Affiliates: AffiliatesColumn,
        Advertisers: AdvertisersColumn,
        Advertiser: AdvertiserColumn,
        Offer: OfferColumn,
        Owner: OwnerColumn,
    },
};
